import * as treeNodeHelpers from './treeNodeHelpers';
import { transformObjectToArray } from '../../../helpers/firebaseTransformations';
import { useTheme } from '@material-ui/styles';
import CodeIcon from '@material-ui/icons/Code';
import DeleteIcon from '@material-ui/icons/Delete';
import Divider from '@material-ui/core/Divider';
import FabCreate from '../../Atoms/FabCreate/';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import ImageIcon from '@material-ui/icons/Image';
import LinkIcon from '@material-ui/icons/Link';
import ListIcon from '@material-ui/icons/List';
import MapIcon from '@material-ui/icons/Map';
import React, { useEffect, useState } from 'react';
import ShortTextIcon from '@material-ui/icons/ShortText';
import SimpleButton from '../../Atoms/SimpleButton';
import SortableTree, { toggleExpandedForAll } from 'react-sortable-tree';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import nodeContentRenderer from '../../../libraries/react-sortable-tree/node-renderer-default';
import useTreeStyles from './styles';
export default ({
    activeDiscoverId,
    createDiscover,
    discoverOther,
    moveNode,
    orderedDiscoverTop,
    removeDiscover,
    setActiveDiscover,
    setToastError,
    topCommonBackgroundImageURL,
}) => {
    const [data, setData] = useState([]);
    const handleToggleExpanded = expanded => {
        setData(toggleExpandedForAll({ treeData: data, expanded }));
    };

    const selectIcon = type => {
        switch (type) {
            case 'map':
                return <MapIcon data-cy="Icon-map" />;
            case 'list':
                return <ListIcon data-cy="Icon-list" />;
            case 'scrollableText':
                return <ShortTextIcon data-cy="Icon-shortText" />;
            case 'link':
                return <LinkIcon data-cy="Icon-link" />;
            case 'canvas':
                return <LinkIcon data-cy="Icon-link" />;
            case 'html':
                return <CodeIcon data-cy="Icon-code" />;
            case 'zoomImage':
                return <ImageIcon data-cy="Icon-image" />;
            default:
                return '';
        }
    };

    // const { setValues, values, errors, handleChange, handleSubmit } = useForm(onSubmit, Validator(FileUploadValidationRules));
    //Responsible for reading local state and producing treeData

    const classes = useTreeStyles({ topCount: 5, commonBackground: topCommonBackgroundImageURL });
    const handleSetActiveDiscover = (id, location, parent_list = undefined) => {
        setActiveDiscover(id, location, parent_list);
    };
    const handleClick = node => {
        //We are dealing with a child-node
        if (node.parent_list) {
            handleSetActiveDiscover(node.id, 'other', node.parent_list);
        } else {
            //we are dealing with top-level
            handleSetActiveDiscover(node.id, 'top');
        }
    };
    const handleRemoveNode = node => {
        if (treeNodeHelpers.hasChildren(node)) {
            setToastError('You cannot remove a list item that current has children. ');
        } else {
            let path;
            if (node.parent_list) {
                path = `other/${node.parent_list}/${node.id}`;
            } else {
                path = `top/${node.id}`;
            }
            removeDiscover({ path: path });
        }
    };

    const generateContentForTitle = node => {
        return (
            <div data-id="clck" onClick={() => handleClick(node)}>
                {
                    <Typography className={classes.name} component="h4">
                        {node.isNameHidden ? '' : node.name}
                    </Typography>
                }
                <span className={classes.icon}>{selectIcon(node.content.type)}</span>
                <span className={classes.remove}>
                    <IconButton
                        className={classes.remove}
                        data-cy="Discover-remove-icon"
                        onClick={() => handleRemoveNode(node)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </span>
            </div>
        );
    };
    function createChildrenForTypeList(parent = null, parentTreeRef = null) {
        let discoverOtherRef = discoverOther[parent.id];
        if (!discoverOtherRef) return [];
        return transformObjectToArray(discoverOtherRef)
            .map(obj => {
                obj.parent_list = parent.id;
                obj.title = generateContentForTitle(obj);
                if (obj.content.type === 'list') {
                    let treeRef = parentTreeRef ? parentTreeRef.children.filter(child => child.id === obj.id)[0] : null; //Search within parent's children to find expanded value
                    obj.expanded = treeRef ? treeRef.expanded : false;
                    obj.children = createChildrenForTypeList(obj, treeRef);
                }

                return obj;
            })
            .sort((a, b) => a.index - b.index); //sorts children by their index value
    }
    useEffect(() => {
        let nodes = orderedDiscoverTop.map(node => {
            if (node.content.type === 'list') {
                let topLevelTreeRef = data.filter(d => d.id === node.id)[0];
                node.expanded = topLevelTreeRef ? topLevelTreeRef.expanded : false;
                node.children = createChildrenForTypeList(node, topLevelTreeRef);
            }
            node.title = generateContentForTitle(node);
            return node;
        });
        setData(nodes);
        // eslint-disable-next-line
    }, [topCommonBackgroundImageURL, orderedDiscoverTop]);

    const handleCreate = () => {
        createDiscover({
            content: {
                type: 'scrollableText',
            },
            location: 'top',
            name: 'New discover',
        });
    };

    const TreeControls = () => {
        const theme = useTheme();
        return (
            <Grid alignItems="center" className={classes.TreeControls} container justify="flex-start">
                <SimpleButton
                    action={() => handleToggleExpanded(true)}
                    bgColor={theme.palette.common.white}
                    icon="expand_more"
                    label="Expand"
                    textColor="black"
                />

                <SimpleButton
                    action={() => handleToggleExpanded(false)}
                    bgColor={theme.palette.common.white}
                    icon="expand_less"
                    label="Collapse"
                    textColor="black"
                />
                <FabCreate action={handleCreate} position="static" />
            </Grid>
        );
    };
    const handleVisibilityToggle = ({ expanded, node }) => {
        // setExpandedDiscover(node.id, expanded)
    };

    const handleTreeOnChange = treeData => {
        moveNode(treeNodeHelpers.prepareTreeDataForUpload(treeData));
        setData(treeData);
    };
    const NODE_HEIGHT = '125';
    return (
        <div
            className={classes.wrapper}
            style={{
                height: 800,
            }}
        >
            <Divider style={{ marginTop: '15px', marginBottom: '15px' }} />
            <TreeControls />
            <SortableTree
                canNodeHaveChildren={node => {
                    if (node.content.type === 'list') {
                        return true;
                    } else {
                    }
                }}
                generateNodeProps={node => {
                    //Only applies topLevelNode classes to topLevelNodes (helpful for background image)
                    let classNames = [classes.node];
                    let style = {};
                    if (!node.parentNode) {
                        classNames = clsx(classes.node, classes.topLevelNode);
                    }
                    if (node.node.shouldUseCommonBackgroundImage) {
                        classNames = clsx(classNames, classes.topLevelBackground);
                        style = { backgroundPosition: `0 -${node.node.index * NODE_HEIGHT}px` };
                    }
                    if (node.node.cardImageURL) {
                        classNames = clsx(classes.node, classes.customBackground);
                        style = {
                            backgroundImage: `url(${node.node.cardImageURL})`,
                        };
                    }
                    if (node.node.id === activeDiscoverId) {
                        classNames = clsx(classNames, 'active');
                    }
                    return {
                        style,
                        className: classNames,
                    };
                }}
                nodeContentRenderer={nodeContentRenderer}
                onChange={handleTreeOnChange}
                onVisibilityToggle={handleVisibilityToggle}
                rowHeight={110}
                treeData={data}
            />
        </div>
    );
};
